/**
 * Wellzora Herbal Care - Bilingual Product Details Dataset
 * 
 * Contains comprehensive bilingual (Urdu & English) herbal details, botanical ingredients,
 * health benefits, usage directions, storage precautions, and package contents for products 1-11.
 */

export const productDetails = {
  1: {
    tagline: "Premium Herbal Formulation",
    taglineUrdu: "معیاری ہربل فارمولا",
    overview: {
      en: "ORX Tablets, developed by WELLZORA HERBAL CARE, are a premium herbal formulation prepared with a carefully selected blend of traditional herbs and natural ingredients. This distinctive formula is designed to provide nutritional herbal support for physical vitality, natural energy, stamina, endurance, and overall men’s wellness.",
      ur: "او آر ایکس ٹیبلیٹس، WELLZORA HERBAL CARE کی تیار کردہ ایک معیاری ہربل فارمولیشن ہے، جو منتخب قدرتی جڑی بوٹیوں اور روایتی اجزاء کے امتزاج سے تیار کی گئی ہے۔ یہ منفرد فارمولا جسمانی توانائی، قدرتی قوتِ برداشت، اسٹیمنا، جسمانی طاقت اور عمومی مردانہ صحت کے لیے ہربل معاونت فراہم کرنے کے لیے ترتیب دیا گیا ہے۔"
    },
    ingredients: {
      en: [
        "Akar Karha (Anacyclus Pyrethrum)",
        "Nutmeg (Jaiphal)",
        "Mace (Javitri)",
        "Cinnamon (Darchini)",
        "Clove (Laung)",
        "Safed Musli (Chlorophytum Borivilianum)",
        "Ashwagandha Nagori (Withania Somnifera)",
        "Kaunch Beej (Mucuna Pruriens)",
        "Tribulus Terrestris (Gokshura)",
        "Tukhm-e-Khubazi (Mallow Seeds)",
        "Ispaghol (Psyllium Husk)",
        "Singhara (Water Chestnut)",
        "Bahman Surkh & Safed (Red & White Behman)",
        "Shilajit (Asphaltum Punjabianum)",
        "Salikha (Cassia Bark)",
        "Talmakhana (Asteracantha Longifolia)",
        "Giloy (Tinospora Cordifolia)",
        "Shatavari (Asparagus Racemosus)",
        "Kabab Chini (Cubeb Pepper)",
        "Aqarqarha (Pyrethrum Root)",
        "Tukhm-e-Khurfa (Purslane Seeds)",
        "Pine Nuts (Mughaz Chilgoza)",
        "Almonds (Mughaz Badam)",
        "Walnuts (Mughaz Akhrot)",
        "Pure Saffron (Zafran)",
        "Natural Honey (Shehad)",
        "Mishri (Rock Sugar)"
      ],
      ur: [
        "اکرکرہ",
        "جائفل",
        "جاوتری",
        "دارچینی",
        "لونگ",
        "سفید موصلی",
        "اسگندھ ناگوری",
        "کونچ بیج",
        "ٹریبولس ٹیریسٹریس (گوکھرو)",
        "تخم گزرا / تخم خبازی",
        "اسپغول",
        "سنگھاڑا",
        "بہمن سرخ و سفید",
        "سلاجیت",
        "سلکھا",
        "تال مکھانہ",
        "گلوئی",
        "شتاوری",
        "کباب چینی",
        "عقرقرحا",
        "تخم خرفہ",
        "مغز چلغوزہ",
        "مغز بادام",
        "مغز اخروٹ",
        "خالص زعفران",
        "شہد",
        "مصری"
      ]
    },
    benefits: {
      en: [
        "Supports overall men’s wellness and vitality",
        "Helps support natural energy, vigor, and stamina",
        "Provides herbal nutritional support during physical tiredness and weakness",
        "Supports physical strength and endurance",
        "Helps maintain an active and energetic lifestyle",
        "Supports overall vitality through a blend of selected natural ingredients"
      ],
      ur: [
        "عمومی مردانہ صحت اور توانائی کے لیے معاون",
        "قدرتی توانائی اور قوتِ برداشت کو سپورٹ کرنے میں مددگار",
        "جسمانی تھکن اور کمزوری کے دوران ہربل معاونت فراہم کرتا ہے",
        "جسمانی طاقت اور اسٹیمنا برقرار رکھنے میں معاون",
        "فعال اور پُرجوش طرزِ زندگی کے لیے مفید",
        "منتخب قدرتی اجزاء کے ذریعے جسم کو غذائی و ہربل معاونت فراہم کرتا ہے"
      ]
    },
    usage: {
      en: "Take 2 tablets, 2–3 times daily, with lukewarm milk, or use as directed by a qualified practitioner.",
      ur: "روزانہ 2 گولیاں، دن میں 2 سے 3 مرتبہ نیم گرم دودھ کے ساتھ استعمال کریں، یا ماہرِ طب کے مشورے کے مطابق استعمال کریں۔"
    },
    precautions: {
      en: [
        "Store in a cool, dry place",
        "Protect from direct sunlight and moisture",
        "Keep out of reach of children",
        "Individual results may vary"
      ],
      ur: [
        "ٹھنڈی اور خشک جگہ پر محفوظ رکھیں",
        "براہِ راست دھوپ اور نمی سے محفوظ رکھیں",
        "بچوں کی پہنچ سے دور رکھیں",
        "نتائج ہر فرد میں مختلف ہو سکتے ہیں"
      ]
    }
  },

  2: {
    tagline: "Herbal Formula for Weight Management",
    taglineUrdu: "قدرتی وزن مینجمنٹ کے لیے ہربل فارمولا",
    overview: {
      en: "Natural Balance Fat Loss, by WELLZORA HERBAL CARE, is a herbal formulation containing a blend of selected natural ingredients. It is designed to provide herbal support for weight management, healthy metabolism, and the body’s natural fat-management process.",
      ur: "Natural Balance Fat Loss، WELLZORA HERBAL CARE کی ایک ہربل فارمولیشن ہے، جس میں منتخب قدرتی اجزاء شامل کیے گئے ہیں۔ یہ فارمولا وزن مینجمنٹ، جسم میں چربی کم کرنے کے عمل اور میٹابولزم کو سپورٹ کرنے کے لیے ترتیب دیا گیا ہے۔"
    },
    ingredients: {
      en: [
        "Garcinia Cambogia Extract (USP) — 300 mg",
        "Green Tea Extract (USP) — 200 mg",
        "Guggul Extract (USP) — 200 mg"
      ],
      ur: [
        "گارسینییا کمبوجیا ایکسٹریکٹ (300 ملی گرام)",
        "سبز چائے (گرین ٹی) ایکسٹریکٹ (200 ملی گرام)",
        "گوگل ایکسٹریکٹ (200 ملی گرام)"
      ]
    },
    benefits: {
      en: [
        "Supports healthy weight management",
        "Helps support the body during weight-loss efforts",
        "Supports natural metabolism and calorie balance",
        "Helps support the body’s natural fat-management process",
        "Supports healthy appetite management and control",
        "Carefully formulated herbal blend suitable for both men and women"
      ],
      ur: [
        "وزن مینجمنٹ اور جسمانی چربی کم کرنے میں معاون",
        "وزن کم کرنے کی کوششوں میں ہربل سپورٹ فراہم کرتا ہے",
        "میٹابولزم کو سپورٹ کرنے میں مددگار",
        "جسم میں چربی کے قدرتی استعمال کے عمل کو سپورٹ کرتا ہے",
        "غیر ضروری بھوک کو کنٹرول کرنے میں معاون",
        "مرد و خواتین دونوں کے لیے یکساں مفید اور معیاری فارمولا"
      ]
    },
    usage: {
      en: "Take 1 capsule twice daily after meals with water, or as directed by a qualified healthcare practitioner.",
      ur: "روزانہ 2 بار، کھانے کے بعد پانی کے ساتھ 1 کیپسول استعمال کریں، یا ماہرِ صحت کے مشورے کے مطابق۔"
    },
    precautions: {
      en: [
        "Store in a cool, dry place",
        "Protect from direct sunlight and moisture",
        "Keep out of reach of children",
        "Do not exceed the recommended daily intake"
      ],
      ur: [
        "ٹھنڈی اور خشک جگہ پر محفوظ رکھیں۔",
        "براہِ راست دھوپ اور نمی سے محفوظ رکھیں۔",
        "بچوں کی پہنچ سے دور رکھیں۔",
        "تجویز کردہ مقدار سے زیادہ استعمال نہ کریں۔"
      ]
    }
  },

  3: {
    tagline: "Traditional Herbal Massage Oil for Men",
    taglineUrdu: "روایتی ہربل مالش آئل برائے مردانہ قوت",
    overview: {
      en: "Habshi Tail Khas by Wellzora Herbal Care is a time-tested traditional herbal massage oil formulated with potent natural botanicals and essential oils. Prepared following classic herbal principles, it is crafted to promote localized circulation, nourish tissues, enhance muscle tone, and support natural male vigor, firmness, and stamina.",
      ur: "حبشی تیل خاص، ویلزورا ہربل کیئر کا ایک روایتی اور آزمودہ ہربل آئل ہے، جو قیمتی قدرتی جڑی بوٹیوں اور خالص روغنیات کے امتزاج سے تیار کیا گیا ہے۔ یہ خاص تیل مقامی دورانِ خون کو متحرک کرنے، پٹھوں کو تقویت دینے، سختی اور قدرتی اسٹیمنا و ٹائمنگ میں معاونت فراہم کرتا ہے۔"
    },
    ingredients: {
      en: [
        "Birbahoti Extract (Scarlet Velvet Mite / Cochineal)",
        "Jund Bedastar (Castoreum)",
        "Akarkara (Anacyclus Pyrethrum)",
        "Malkangni Oil (Celastrus Paniculatus)",
        "Clove Oil (Laung)",
        "Cinnamon Oil (Darchini)",
        "Pure Sesame Oil (Til)",
        "Extra Virgin Olive Oil (Zaitoon)"
      ],
      ur: [
        "بیر بہوٹی",
        "جند بیدستر",
        "اکرکرہ",
        "روغن مالکنگنی",
        "روغن لونگ",
        "روغن دارچینی",
        "روغنِ تل",
        "روغنِ زیتون"
      ]
    },
    benefits: {
      en: [
        "Supports local blood circulation and muscle tissue nourishment",
        "Helps enhance natural strength, firmness, and stamina",
        "Aids in relieving muscular fatigue and weakness",
        "Promotes vitality, confidence, and marital endurance naturally",
        "100% natural herbal formula with no harmful chemicals or steroids"
      ],
      ur: [
        "مقامی دورانِ خون کو بہتر بنا کر عضلات کو تقویت دیتا ہے",
        "قدرتی سختی، قوتِ برداشت اور ٹائمنگ میں مددگار",
        "پٹھوں کی کمزوری اور سستی کو دور کرنے میں معاون",
        "ازدواجی زندگی میں اعتماد اور تسکین کو فروغ دیتا ہے",
        "خالص قدرتی اجزاء پر مشتمل، محفوظ اور کیمیکلز سے پاک"
      ]
    },
    usage: {
      en: "Apply 4 to 6 drops externally to the shaft (avoiding the tip and urethra) and gently massage in an upward direction for 5 to 10 minutes before bedtime, or as directed by a healthcare practitioner.",
      ur: "رات کو سوتے وقت 4 سے 6 قطرے لے کر حشفہ (سامنے کا حصہ) چھوڑ کر باقی حصے پر 5 سے 10 منٹ نرمی سے مالش کریں، یا ماہرِ طب کے مشورے کے مطابق استعمال کریں۔"
    },
    precautions: {
      en: [
        "For external use only",
        "Do not apply on open wounds, cuts, or irritated skin",
        "Discontinue use if any allergic reaction or irritation occurs",
        "Store in a cool, dry place away from direct sunlight",
        "Keep out of reach of children"
      ],
      ur: [
        "صرف بیرونی استعمال کے لیے ہے",
        "زخم، کٹ یا چھلی ہوئی جلد پر استعمال نہ کریں",
        "کسی بھی قسم کی خارش یا جلن کی صورت میں استعمال روک دیں",
        "خشک اور ٹھنڈی جگہ پر براہِ راست دھوپ سے محفوظ رکھیں",
        "بچوں کی پہنچ سے دور رکھیں"
      ]
    }
  },

  4: {
    tagline: "Premium Herbal Formulation",
    taglineUrdu: "خصوصی ہربل فارمولیشن",
    overview: {
      en: "Titan Turkish Majoon, by Wellzora Herbal Care, is a carefully formulated herbal preparation made with a blend of selected natural herbs and traditional ingredients. This distinctive formula is developed to support physical strength, natural energy, nervous system health, stamina, and overall male wellness.",
      ur: "ٹائٹن ترکش معجون، ویلزورا ہربل کیئر کی ایک خصوصی ہربل فارمولیشن ہے، جسے منتخب قدرتی جڑی بوٹیوں اور قیمتی اجزاء کے امتزاج سے تیار کیا گیا ہے۔ یہ منفرد فارمولا جسمانی توانائی، اعصابی صحت، قوتِ برداشت اور عمومی مردانہ صحت کو سپورٹ کرنے کے لیے ترتیب دیا گیا ہے۔"
    },
    ingredients: {
      en: [
        "Pistachio (Pista)",
        "Pine Nuts (Chilgoza)",
        "Sesame Seeds (Til)",
        "Galangal (Khulanjan)",
        "Shatavari",
        "White Behman",
        "Sweet Violet (Gul-e-Banafsha)",
        "Ginger (Adrak)",
        "Cinnamon (Darchini)",
        "Valerian Root (Sumbul-ut-Teeb)",
        "Nut Grass (Nagar Motha)",
        "Clove (Laung)",
        "Cubeb Pepper (Kabab Chini)",
        "Ashwagandha (Asgandh)",
        "Carrot Seeds (Tukhm-e-Gajar)",
        "Radish Seeds (Tukhm-e-Mooli)",
        "Onion (Piyaz)",
        "Harmal",
        "Inderjo",
        "Wild Ginger (Jangli Adrak)",
        "Nutmeg (Jaiphal)",
        "Stone Flower (Pathar Phool)",
        "Long Pepper (Daraz Mirch)",
        "Salab Panja",
        "Mint (Pudina)",
        "Colchicum (Suranjan)",
        "Akarkara",
        "Mastic Gum (Mastagi)",
        "Balsam",
        "Pure Saffron (Zafran)",
        "Musk (Kasturi)",
        "Silver Leaf (Warq-e-Chandi)"
      ],
      ur: [
        "پستہ",
        "چلغوزہ",
        "تل",
        "خولنجان",
        "شتاوری",
        "بہمن سفید",
        "گلِ بنفشہ",
        "ادرک",
        "دارچینی",
        "سنبل الطیب",
        "ناگر موتھا",
        "لونگ",
        "کباب چینی",
        "اشوگندھا",
        "گاجر کے بیج",
        "مولی کے بیج",
        "پیاز",
        "حرمل",
        "اندرجو",
        "جنگلی ادرک",
        "جائفل",
        "پتھر پھول",
        "دراز مرچ",
        "سالم پنجہ",
        "پودینہ",
        "سورنجان",
        "اکرکرہ",
        "مستگی",
        "بلسان",
        "زعفران",
        "مشک",
        "چاندی کا ورق"
      ]
    },
    benefits: {
      en: [
        "Supports physical strength and natural energy",
        "Helps support nervous system health",
        "Supports natural stamina and endurance",
        "Helps with everyday tiredness and weakness",
        "Supports male wellness and vitality",
        "Helps maintain overall physical performance"
      ],
      ur: [
        "جسمانی طاقت اور توانائی کو سپورٹ کرنے میں معاون",
        "اعصابی صحت اور مضبوطی کے لیے مفید",
        "قدرتی قوتِ برداشت کو بہتر بنانے میں مددگار",
        "جسمانی تھکن اور کمزوری میں معاون",
        "عمومی مردانہ صحت اور توانائی کو سپورٹ کرتا ہے",
        "روزمرہ جسمانی کارکردگی اور اسٹیمنا کے لیے معاون"
      ]
    },
    usage: {
      en: "Take one teaspoon (approximately 10 g) twice daily with lukewarm milk, or use as directed by a qualified practitioner.",
      ur: "ایک چائے کا چمچ (تقریباً 10 گرام) دن میں دو مرتبہ نیم گرم دودھ کے ساتھ استعمال کریں، یا ماہرِ طب کے مشورے کے مطابق استعمال کریں۔"
    },
    precautions: {
      en: [
        "Store in a cool, dry place",
        "Protect from direct sunlight and moisture",
        "Keep out of reach of children"
      ],
      ur: [
        "خشک اور ٹھنڈی جگہ پر محفوظ رکھیں۔",
        "براہِ راست دھوپ اور نمی سے دور رکھیں۔",
        "بچوں کی پہنچ سے دور رکھیں"
      ]
    }
  },

  5: {
    tagline: "100% Herbal Men’s Essential Oil",
    taglineUrdu: "100% ہربل ایسنشل آئل برائے مردانہ صحت",
    overview: {
      en: "Big Bull Oil, by WELLZORA HERBAL CARE, is a specially formulated herbal oil made with a blend of selected natural ingredients. The formula is designed to provide herbal support for men’s wellness, physical energy, stamina, endurance, and marital well-being.",
      ur: "Big Bull Oil، WELLZORA HERBAL CARE کی ایک خصوصی ہربل آئل فارمولیشن ہے، جسے منتخب قدرتی اجزاء کے امتزاج سے تیار کیا گیا ہے۔ یہ فارمولا مردانہ صحت، جسمانی توانائی، اسٹیمنا اور ازدواجی کارکردگی کے لیے ہربل معاونت فراہم کرنے کے لیے ترتیب دیا گیا ہے۔"
    },
    ingredients: {
      en: [
        "Olive Oil (Roghan-e-Zaitoon)",
        "Ginger (Adrak)",
        "Cinnamon (Darchini)",
        "Clove (Laung)",
        "Akar Karha (Anacyclus Pyrethrum)",
        "Cubeb Pepper (Kabab Chini)",
        "Ashwagandha (Withania Somnifera)",
        "Mint (Pudina)"
      ],
      ur: [
        "زیتون کا تیل",
        "ادرک",
        "دارچینی",
        "لونگ",
        "اکرکرہ",
        "کباب چینی",
        "اشوگندھا",
        "پودینہ"
      ]
    },
    benefits: {
      en: [
        "Supports men’s overall wellness and vitality",
        "Helps support natural stamina and endurance",
        "Provides herbal support for physical strength and energy",
        "Supports marital performance and confidence",
        "Formulated with selected natural herbal ingredients"
      ],
      ur: [
        "مردانہ صحت اور توانائی کے لیے معاون",
        "قدرتی اسٹیمنا اور قوتِ برداشت کو سپورٹ کرتا ہے",
        "جسمانی طاقت اور توانائی کے لیے مددگار",
        "ازدواجی کارکردگی کے لیے معاونت فراہم کرتا ہے",
        "منتخب قدرتی ہربل اجزاء پر مشتمل فارمولا"
      ]
    },
    usage: {
      en: "Apply a suitable amount of oil externally to the desired area and massage gently. For best use, follow the instructions provided on the original product label.",
      ur: "مطلوبہ مقدار میں تیل لے کر بیرونی طور پر متعلقہ حصے پر نرمی سے مساج کریں۔ بہتر نتائج کے لیے پروڈکٹ کے اصل لیبل پر دی گئی ہدایات کے مطابق استعمال کریں۔"
    },
    precautions: {
      en: [
        "For external use only",
        "Avoid contact with eyes and broken or irritated skin",
        "Discontinue use if irritation or an allergic reaction occurs",
        "Keep out of reach of children"
      ],
      ur: [
        "صرف بیرونی استعمال کے لیے۔",
        "آنکھوں اور زخم والی جگہ سے دور رکھیں۔",
        "جلن یا الرجی کی صورت میں استعمال روک دیں۔",
        "بچوں کی پہنچ سے دور رکھیں"
      ]
    }
  },

  6: {
    tagline: "Complete Herbal Solution for Hair Health",
    taglineUrdu: "قدرتی جڑی بوٹیوں سے تیار، بالوں کا مکمل علاج",
    overview: {
      en: "Regrow Herbal Hair Oil by WELLZORA HERBAL CARE is an intensive botanical formulation crafted from traditional time-tested herbs and nourishing botanical oils. It penetrates deeply into the scalp to awaken dormant hair follicles, strengthen weak roots, combat hair fall, eliminate stubborn dandruff, and promote thick, healthy, and lustrous hair growth.",
      ur: "ریگرو ہربل ہیئر آئل، WELLZORA HERBAL CARE کی ایک خالص قدرتی اور جامع فارمولیشن ہے جو بالوں کی جڑوں کو مضبوط اور سر کی جلد کو غذائیت فراہم کرتی ہے۔ منتخب قدرتی جڑی بوٹیوں اور خالص روغنیات سے تیار کردہ یہ تیل بالوں کا گرنا روکنے، خشکی اور سکری کا خاتمہ کرنے، اور نئے گھنے و چمکدار بال اگانے میں انتہائی مؤثر ہے۔"
    },
    ingredients: {
      en: [
        "Amla / Indian Gooseberry (Phyllanthus Emblica)",
        "Bhringraj / False Daisy (Eclipta Alba)",
        "Shikakai (Acacia Concinna)",
        "Brahmi (Bacopa Monnieri)",
        "Fenugreek Seeds / Methi Dana (Trigonella Foenum-Graecum)",
        "Neem Oil (Azadirachta Indica)",
        "Castor Oil (Ricinus Communis)",
        "Sweet Almond Oil (Prunus Dulcis)",
        "Pure Coconut Oil (Cocos Nucifera)",
        "Black Seed Oil / Kalonji (Nigella Sativa)"
      ],
      ur: [
        "آملہ",
        "بھرنگراج",
        "شیکاکائی",
        "برہمی",
        "میتھی دانہ",
        "روغنِ نیم",
        "روغنِ ارنڈ (کیسٹر آئل)",
        "روغنِ بادام شیریں",
        "خالص ناریل کا تیل",
        "روغنِ کلونجی"
      ]
    },
    benefits: {
      en: [
        "Stimulates hair roots and encourages natural hair regrowth",
        "Significantly reduces hair fall, hair thinning, and breakage",
        "Eliminates scalp dandruff, flaking, and fungal irritation",
        "Helps delay premature greying and restores natural vibrancy",
        "Provides deep conditioning, leaving hair soft, voluminous, and strong",
        "100% natural, chemical-free formulation without mineral oils or silicones"
      ],
      ur: [
        "بالوں کی جڑوں کو متحرک کر کے قدرتی ری گروتھ کو فروغ دیتا ہے",
        "بالوں کے گرنے، ٹوٹنے اور باریک ہونے کو نمایاں طور پر روکتا ہے",
        "سر کی جلد سے خشکی، سکری اور خارش کو جڑ سے ختم کرتا ہے",
        "بالوں کو قبل از وقت سفید ہونے سے روکتا ہے اور جڑیں مضبوط بناتا ہے",
        "بالوں کو قدرتی چمک، نرمی اور گھنا پن عطا کرتا ہے",
        "100% قدرتی اجزاء پر مشتمل، منرل آئل اور کیمیکلز سے بالکل پاک"
      ]
    },
    usage: {
      en: "Apply a generous amount of oil directly to the scalp and hair strands. Gently massage with fingertips in circular motions for 5 to 10 minutes. Leave on for at least 2 hours or overnight before washing with a mild herbal shampoo. Use 3 to 4 times a week for best results.",
      ur: "مناسب مقدار میں تیل بالوں کی جڑوں اور سر کی جلد پر لگائیں اور 5 سے 10 منٹ تک انگلیوں کی پوروں سے ہلکا مساج کریں۔ کم از کم 2 گھنٹے یا رات بھر لگا رہنے دیں، پھر کسی اچھے ہربل شیمپو سے دھو لیں۔ ہفتے میں 3 سے 4 بار استعمال کریں۔"
    },
    precautions: {
      en: [
        "For external application only",
        "Avoid direct contact with eyes; rinse immediately with water if contact occurs",
        "Store in a cool, dry place away from direct sunlight",
        "Keep out of reach of children"
      ],
      ur: [
        "صرف بیرونی استعمال کے لیے ہے",
        "آنکھوں میں جانے سے بچائیں؛ چلے جانے پر فوری صاف پانی سے دھوئیں",
        "براہِ راست دھوپ اور نمی سے محفوظ ٹھنڈی جگہ رکھیں",
        "بچوں کی پہنچ سے دور رکھیں"
      ]
    }
  },

  7: {
    tagline: "Premium Herbal Formulation",
    taglineUrdu: "خصوصی پریمیم ہربل فارمولیشن",
    overview: {
      en: "Premium Titan Turkish Majoon, by Wellzora Herbal Care, is a carefully formulated herbal preparation made with a blend of selected natural herbs and traditional ingredients. This distinctive formula is developed to support physical strength, natural energy, nervous system health, stamina, and overall male wellness.",
      ur: "پریمیم ٹائٹن ترکش معجون، ویلزورا ہربل کیئر کی ایک خصوصی ہربل فارمولیشن ہے، جسے منتخب قدرتی جڑی بوٹیوں اور قیمتی اجزاء کے امتزاج سے تیار کیا گیا ہے۔ یہ منفرد فارمولا جسمانی توانائی، اعصابی صحت، قوتِ برداشت اور عمومی مردانہ صحت کو سپورٹ کرنے کے لیے ترتیب دیا گیا ہے۔"
    },
    ingredients: {
      en: [
        "Pistachio (Pista)",
        "Pine Nuts (Chilgoza)",
        "Sesame Seeds (Til)",
        "Galangal (Khulanjan)",
        "Shatavari",
        "White Behman",
        "Sweet Violet (Gul-e-Banafsha)",
        "Ginger (Adrak)",
        "Cinnamon (Darchini)",
        "Valerian Root (Sumbul-ut-Teeb)",
        "Nut Grass (Nagar Motha)",
        "Clove (Laung)",
        "Cubeb Pepper (Kabab Chini)",
        "Ashwagandha (Asgandh)",
        "Carrot Seeds (Tukhm-e-Gajar)",
        "Radish Seeds (Tukhm-e-Mooli)",
        "Onion (Piyaz)",
        "Harmal",
        "Inderjo",
        "Wild Ginger (Jangli Adrak)",
        "Nutmeg (Jaiphal)",
        "Stone Flower (Pathar Phool)",
        "Long Pepper (Daraz Mirch)",
        "Salab Panja",
        "Mint (Pudina)",
        "Colchicum (Suranjan)",
        "Akarkara",
        "Mastic Gum (Mastagi)",
        "Balsam",
        "Pure Saffron (Zafran)",
        "Musk (Kasturi)",
        "Silver Leaf (Warq-e-Chandi)"
      ],
      ur: [
        "پستہ",
        "چلغوزہ",
        "تل",
        "خولنجان",
        "شتاوری",
        "بہمن سفید",
        "گلِ بنفشہ",
        "ادرک",
        "دارچینی",
        "سنبل الطیب",
        "ناگر موتھا",
        "لونگ",
        "کباب چینی",
        "اشوگندھا",
        "گاجر کے بیج",
        "مولی کے بیج",
        "پیاز",
        "حرمل",
        "اندرجو",
        "جنگلی ادرک",
        "جائفل",
        "پتھر پھول",
        "دراز مرچ",
        "سالم پنجہ",
        "پودینہ",
        "سورنجان",
        "اکرکرہ",
        "مستگی",
        "بلسان",
        "زعفران",
        "مشک",
        "چاندی کا ورق"
      ]
    },
    benefits: {
      en: [
        "Supports physical strength and natural energy",
        "Helps support nervous system health",
        "Supports natural stamina and endurance",
        "Helps with everyday tiredness and weakness",
        "Supports male wellness and vitality",
        "Helps maintain overall physical performance"
      ],
      ur: [
        "جسمانی طاقت اور توانائی کو سپورٹ کرنے میں معاون",
        "اعصابی صحت اور مضبوطی کے لیے مفید",
        "قدرتی قوتِ برداشت کو بہتر بنانے میں مددگار",
        "جسمانی تھکن اور کمزوری میں معاون",
        "عمومی مردانہ صحت اور توانائی کو سپورٹ کرتا ہے",
        "روزمرہ جسمانی کارکردگی اور اسٹیمنا کے لیے معاون"
      ]
    },
    usage: {
      en: "Take one teaspoon (approximately 10 g) twice daily with lukewarm milk, or use as directed by a qualified practitioner.",
      ur: "ایک چائے کا چمچ (تقریباً 10 گرام) دن میں دو مرتبہ نیم گرم دودھ کے ساتھ استعمال کریں، یا ماہرِ طب کے مشورے کے مطابق استعمال کریں۔"
    },
    precautions: {
      en: [
        "Store in a cool, dry place",
        "Protect from direct sunlight and moisture",
        "Keep out of reach of children"
      ],
      ur: [
        "خشک اور ٹھنڈی جگہ پر محفوظ رکھیں۔",
        "براہِ راست دھوپ اور نمی سے دور رکھیں۔",
        "بچوں کی پہنچ سے دور رکھیں"
      ]
    }
  },

  8: {
    tagline: "Natural Herbal Formula for Digestive Wellness",
    taglineUrdu: "قدرتی ہربل فارمولا برائے معدہ",
    overview: {
      en: "Rahat-e-Meda Safoof, by WELLZORA HERBAL CARE, is a traditional herbal formulation prepared with a blend of selected natural ingredients. It is designed to provide herbal support for digestive wellness, stomach comfort, and common digestive concerns such as gas and indigestion.",
      ur: "راحتِ معدہ سفوف، WELLZORA HERBAL CARE کا روایتی ہربل فارمولا ہے، جو منتخب قدرتی اجزاء کے امتزاج سے تیار کیا گیا ہے۔ یہ فارمولا معدے کی صحت، بہتر ہاضمے اور گیس، بدہضمی و پیٹ کی عمومی بے آرامی میں ہربل معاونت کے لیے ترتیب دیا گیا ہے۔"
    },
    ingredients: {
      en: [
        "Fennel (Saunf)",
        "Ajwain (Trachyspermum Ammi)",
        "White Cumin (Zeera Safed)",
        "Black Cumin (Zeera Siyah)",
        "Ginger (Adrak / Sonth)",
        "Mint (Pudina)",
        "Green Cardamom (Elaichi Sabz)",
        "Cinnamon (Darchini)",
        "Black Salt (Kala Namak)",
        "Asafoetida (Hing)"
      ],
      ur: [
        "سونف",
        "اجوائن",
        "زیرہ سفید",
        "زیرہ سیاہ",
        "ادرک",
        "پودینہ",
        "الائچی سبز",
        "دارچینی",
        "نمکِ سیاہ",
        "ہینگ"
      ]
    },
    benefits: {
      en: [
        "Helps support digestive health",
        "Provides herbal support for gas and bloating",
        "Supports comfortable digestion",
        "Helps with occasional indigestion",
        "Supports overall stomach comfort"
      ],
      ur: [
        "گیس اور اپھارے میں معاون",
        "بدہضمی میں مددگار",
        "معدے کو سکون پہنچانے میں معاون",
        "پیٹ کی عمومی بے آرامی میں مددگار",
        "صحت مند ہاضمے کو سپورٹ کرتا ہے"
      ]
    },
    usage: {
      en: "Use in an appropriate amount as directed on the product label, or as advised by a qualified practitioner.",
      ur: "مناسب مقدار میں استعمال کریں، یا ماہرِ طب کے مشورے کے مطابق استعمال کریں۔"
    },
    precautions: {
      en: [
        "Store in a cool, dry place",
        "Protect from moisture and direct sunlight",
        "Keep out of reach of children"
      ],
      ur: [
        "خشک اور ٹھنڈی جگہ پر محفوظ رکھیں۔",
        "نمی اور براہِ راست دھوپ سے محفوظ رکھیں۔",
        "بچوں کی پہنچ سے دور رکھیں۔"
      ]
    }
  },

  9: {
    tagline: "Premium Herbal Formula",
    taglineUrdu: "معیاری ہربل فارمولا برائے مردانہ قوت و اعصاب",
    overview: {
      en: "Safoof Zakawat is a quality herbal formulation developed by WELLZORA HERBAL CARE, prepared with a blend of selected natural herbs and traditional ingredients. This formula is designed to provide herbal support for physical energy, stamina, endurance, nervous system health, and overall men’s wellness.",
      ur: "سفوف ذکاوت، WELLZORA HERBAL CARE کا تیار کردہ ایک معیاری ہربل فارمولا ہے، جو منتخب قدرتی جڑی بوٹیوں اور روایتی اجزاء کے امتزاج سے تیار کیا گیا ہے۔ یہ فارمولا جسمانی توانائی، قوتِ برداشت، اعصابی صحت اور عمومی مردانہ صحت کے لیے ہربل معاونت فراہم کرنے کے لیے ترتیب دیا گیا ہے۔"
    },
    ingredients: {
      en: [
        "Safed Musli (Chlorophytum Borivilianum)",
        "Ashwagandha (Withania Somnifera)",
        "Black Seed / Kalonji (Nigella Sativa)",
        "Clove (Laung)",
        "Cinnamon (Darchini)",
        "Sesame Seeds (Tal/Til)"
      ],
      ur: [
        "سفید موصلی",
        "اشوگندھا",
        "کلونجی",
        "لونگ",
        "دارچینی",
        "تعلیہ / تل"
      ]
    },
    benefits: {
      en: [
        "Supports physical strength and natural energy",
        "Helps support stamina and endurance",
        "Supports nervous system health",
        "Provides herbal support during physical tiredness and weakness",
        "Supports overall male wellness and vitality",
        "Helps maintain an active and energetic lifestyle"
      ],
      ur: [
        "جسمانی طاقت اور توانائی کے لیے معاون",
        "قدرتی قوتِ برداشت اور اسٹیمنا کو سپورٹ کرتا ہے",
        "اعصابی صحت اور مضبوطی کے لیے مددگار",
        "جسمانی تھکن اور کمزوری میں معاون",
        "عمومی مردانہ صحت اور وٹیلٹی کو سپورٹ کرتا ہے",
        "فعال اور پُرجوش طرزِ زندگی کے لیے مفید"
      ]
    },
    usage: {
      en: "Take one teaspoon 1–2 times daily with lukewarm milk or water, or use as directed by a qualified practitioner.",
      ur: "ایک چائے کا چمچ روزانہ 1–2 مرتبہ نیم گرم دودھ یا پانی کے ساتھ استعمال کریں، یا ماہرِ طب کے مشورے کے مطابق استعمال کریں۔"
    },
    precautions: {
      en: [
        "Store in a cool, dry place",
        "Protect from direct sunlight and moisture",
        "Keep out of reach of children",
        "Do not exceed the recommended serving"
      ],
      ur: [
        "ٹھنڈی اور خشک جگہ پر محفوظ رکھیں",
        "براہِ راست دھوپ اور نمی سے محفوظ رکھیں",
        "بچوں کی پہنچ سے دور رکھیں",
        "مقررہ مقدار سے زیادہ استعمال نہ کریں"
      ]
    }
  },

  10: {
    tagline: "Premium Herbal Oil for Men’s Wellness",
    taglineUrdu: "مردانہ صحت کے لیے خصوصی ہربل آئل",
    overview: {
      en: "Titan Turkish Tilla, by WELLZORA HERBAL CARE, is a specially formulated herbal oil made with a blend of selected natural ingredients. It is intended for external use and provides herbal support for men’s wellness, physical vitality, stamina, and marital well-being.",
      ur: "ٹائٹن ترکش تِلا، WELLZORA HERBAL CARE کی خصوصی ہربل آئل فارمولیشن ہے، جو منتخب قدرتی اجزاء کے امتزاج سے تیار کیا گیا ہے۔ یہ بیرونی استعمال کے لیے تیار کیا گیا فارمولا مردانہ صحت، توانائی، قوتِ برداشت اور ازدواجی کارکردگی کے لیے معاونت فراہم کرتا ہے۔"
    },
    ingredients: {
      en: [
        "Olive Oil (Zaitoon)",
        "Ginger (Adrak)",
        "Cinnamon (Darchini)",
        "Clove (Laung)",
        "Akar Karha (Anacyclus Pyrethrum)",
        "Cubeb Pepper (Kabab Chini)",
        "Ashwagandha (Withania Somnifera)",
        "Mint (Pudina)"
      ],
      ur: [
        "زیتون کا تیل",
        "ادرک",
        "دارچینی",
        "لونگ",
        "اکرکرہ",
        "کباب چینی",
        "اشوگندھا",
        "پودینہ"
      ]
    },
    benefits: {
      en: [
        "Supports men’s overall wellness and vitality",
        "Helps support physical strength and stamina",
        "Provides herbal support for marital performance",
        "Helps promote a feeling of relaxation and freshness through external massage",
        "Supports an active and energetic lifestyle"
      ],
      ur: [
        "مردانہ صحت اور توانائی کے لیے معاون",
        "جسمانی قوت اور اسٹیمنا کو سپورٹ کرنے میں مددگار",
        "ازدواجی کارکردگی کے لیے ہربل معاونت",
        "جسمانی تھکن اور کمزوری میں معاون",
        "بیرونی مساج کے ذریعے آرام اور تازگی کا احساس فراہم کرنے میں مددگار"
      ]
    },
    usage: {
      en: "Apply a suitable amount of oil externally to the desired area and massage gently for 5–10 minutes. Use regularly as directed on the product label.",
      ur: "مناسب مقدار میں تیل لے کر متعلقہ بیرونی حصے پر لگائیں اور 5–10 منٹ نرمی سے مساج کریں۔ بہتر استعمال کے لیے باقاعدگی سے استعمال کریں اور پروڈکٹ لیبل کی ہدایات کو ترجیح دیں۔"
    },
    precautions: {
      en: [
        "For external use only",
        "Avoid contact with eyes, wounds, and irritated or sensitive skin",
        "Perform a small patch test before first use",
        "Discontinue use if irritation, itching, or an allergic reaction occurs",
        "Keep out of reach of children",
        "Store in a cool, dry place"
      ],
      ur: [
        "صرف بیرونی استعمال کے لیے",
        "آنکھوں، زخم اور حساس یا متاثرہ جلد سے دور رکھیں",
        "پہلی بار استعمال سے پہلے جلد کے چھوٹے حصے پر ٹیسٹ کر لیں",
        "جلن، خارش یا الرجی کی صورت میں استعمال بند کر دیں",
        "بچوں کی پہنچ سے دور رکھیں",
        "ٹھنڈی اور خشک جگہ پر محفوظ رکھیں"
      ]
    }
  },

  11: {
    tagline: "Complete 30-Day Herbal Program",
    taglineUrdu: "شادی کورس — 30 دن کا مکمل ہربل کورس",
    overview: {
      en: "If you are getting married soon or have recently started your married life, the WELLZORA HERBAL CARE 30-Day Marriage Course is a comprehensive herbal support program designed to support male wellness, physical vitality, stamina, and marital well-being. The WELLZORA HERBAL CARE Marriage Course combines selected herbal products into one comprehensive program designed to provide support for physical vitality, stamina, male wellness, and overall marital well-being.",
      ur: "اگر آپ کی شادی قریب ہے یا حال ہی میں شادی ہوئی ہے، تو WELLZORA HERBAL CARE کا خصوصی 30-Day Marriage Course مردانہ صحت، جسمانی توانائی اور ازدواجی زندگی کے لیے ایک جامع ہربل سپورٹ پروگرام ہے۔ WELLZORA HERBAL CARE Marriage Course میں منتخب ہربل پروڈکٹس کا ایک مکمل پیکج شامل ہے، جسے جسمانی توانائی، قوتِ برداشت، مردانہ صحت اور ازدواجی زندگی کی مجموعی معاونت کے لیے ترتیب دیا گیا ہے۔"
    },
    ingredients: {
      en: [
        "ORX Tablets (Botanical Vitality & Nervous Strength Formula)",
        "Safoof Zakawat (Herbal Vitality & Bladder Balance Blend)",
        "Titan Turkish Majoon (Natural Herbal Energy Jam)",
        "Rahat-e-Meda Safoof (Digestive Health & Gastric Comfort Blend)",
        "Titan Turkish Tilla (External Massage Oil for Men)"
      ],
      ur: [
        "او آر ایکس ٹیبلیٹس (ہربل وٹیلٹی و اعصابی فارمولا)",
        "سفوف ذکاوت (ہربل انڈیورنس پاؤڈر)",
        "ٹائٹن ترکش معجون (طاقت و توانائی کا معجون)",
        "راحتِ معدہ سفوف (ہاضمہ و معدہ فارمولا)",
        "ٹائٹن ترکش تِلا (بیرونی مالش کا ہربل تیل)"
      ]
    },
    benefits: {
      en: [
        "Comprehensive 360-degree support for marital vitality and endurance",
        "Helps eliminate physical tiredness, exhaustion, and bodily weakness",
        "Addresses timing, stamina, and marital performance concerns",
        "Strengthens nerves and boosts physical energy levels",
        "Resolves digestive heat and optimizes nutrient absorption",
        "Formulated with 100% natural, halal, and steroid-free ingredients"
      ],
      ur: [
        "ازدواجی توانائی اور قوتِ برداشت کے لیے مکمل 360 ڈگری ہربل معاونت",
        "جسمانی کمزوری، تھکن اور سستی کا خاتمہ",
        "ٹائمنگ، اسٹیمنا اور ازدواجی کارکردگی کے خدشات کا ازالہ",
        "اعصاب کو تقویت دے کر جسمانی توانائی کی سطح کو بلند کرتا ہے",
        "معدے کی گرمی اور بدہضمی دور کر کے غذائیت کے جذب کو بہتر بناتا ہے",
        "100% قدرتی، حلال اور سٹیرائیڈ سے پاک اجزاء پر مشتمل"
      ]
    },
    usage: {
      en: "Follow individual product instructions: Take ORX Tablets and Titan Turkish Majoon with lukewarm milk; take Safoof Zakawat and Rahat-e-Meda Safoof as directed; apply Titan Turkish Tilla externally once daily for gentle massage. Use consistently throughout the 30-day course.",
      ur: "پیکج میں شامل ہر پروڈکٹ کو ہدایات کے مطابق استعمال کریں: او آر ایکس ٹیبلیٹس اور ٹائٹن ترکش معجون نیم گرم دودھ کے ساتھ لیں؛ سفوف ذکاوت اور راحتِ معدہ سفوف بتائے گئے طریقے سے استعمال کریں؛ اور ٹائٹن ترکش تِلا سے روزانہ نرمی سے مساج کریں۔ 30 دن تک باقاعدگی سے کورس مکمل کریں۔"
    },
    precautions: {
      en: [
        "Store all products in a cool, dry place away from direct sunlight",
        "Titan Turkish Tilla is strictly for external use only",
        "Keep out of reach of children",
        "Follow the recommended dosages for each product without skipping days",
        "Consult a qualified practitioner if you have specific chronic conditions"
      ],
      ur: [
        "تمام پروڈکٹس کو خشک اور ٹھنڈی جگہ پر براہِ راست دھوپ سے محفوظ رکھیں",
        "ٹائٹن ترکش تِلا صرف بیرونی استعمال کے لیے ہے",
        "بچوں کی پہنچ سے دور رکھیں",
        "باقاعدہ نتائج کے لیے تجویز کردہ مقدار کے مطابق ناغہ کیے بغیر استعمال کریں",
        "کسی پرانے یا پیچیدہ عارضے کی صورت میں ماہرِ طب سے رجوع کریں"
      ]
    },
    packageIncludes: [
      {
        name: "ORX Tablets",
        nameUrdu: "او آر ایکس ٹیبلیٹس",
        size: "30 Tablets (1 Box)",
        image: "/src/assets/Products/WhatsApp Image 2026-08-31 at 16.04.46 (1).jpeg"
      },
      {
        name: "Safoof Zakawat",
        nameUrdu: "سفوف ذکاوت",
        size: "100 gram (1 Box)",
        image: "/src/assets/Products/WhatsApp Image 2026-08-31 at 16.04.47 (1).jpeg"
      },
      {
        name: "Titan Turkish Majoon",
        nameUrdu: "ٹائٹن ترکش مجون",
        size: "130 gram (1 Box)",
        image: "/src/assets/Products/WhatsApp Image 2026-08-31 at 16.04.44 (1).jpeg"
      },
      {
        name: "Rahat Meda Safoof",
        nameUrdu: "راحت معدہ سفوف",
        size: "100 gram (1 Box)",
        image: "/src/assets/Products/WhatsApp Image 2026-08-31 at 16.04.47 (2).jpeg"
      },
      {
        name: "Titan Turkish Tilla",
        nameUrdu: "ٹائٹن ترکش تِلا",
        size: "15ml (1 Bottle)",
        image: "/src/assets/Products/image_639be8.jpeg"
      }
    ],
    designedToSupport: {
      en: [
        "Physical weakness and fatigue",
        "Concerns related to marital performance",
        "Timing and stamina concerns",
        "Physical energy and endurance",
        "Post-urination dribbling concerns",
        "Leakage and involuntary dribbling concerns",
        "General male wellness and vitality",
        "Confidence and well-being in married life"
      ],
      ur: [
        "جسمانی کمزوری اور تھکن",
        "ازدواجی کارکردگی سے متعلق خدشات",
        "ٹائمنگ اور قوتِ برداشت کی کمی",
        "جسمانی اسٹیمنا اور توانائی کی سپورٹ",
        "پیشاب کے بعد ڈرِبلنگ کے مسائل",
        "لیکیج اور غیر ارادی قطرے آنے کی شکایت",
        "عمومی مردانہ صحت اور وٹیلٹی",
        "ازدواجی زندگی میں اعتماد اور اطمینان کی معاونت"
      ]
    },
    packageFeatures: {
      en: [
        "DRAP-Registered Products",
        "Premium Herbal Quality",
        "Halal Ingredients",
        "Steroid-Free",
        "Quality Tested"
      ],
      ur: [
        "DRAP رجسٹرڈ پروڈکٹس",
        "پریمیم ہربل کوالٹی",
        "100% حلال اجزاء",
        "سٹیرائیڈز سے مکمل پاک",
        "کوالٹی ٹیسٹڈ اور محفوظ"
      ]
    }
  }
};

/**
 * Retrieve herbal details for a product by ID.
 * @param {number|string} productId - Product ID (1-11)
 * @returns {object|null} Product detail object or null if not found
 */
export function getProductDetails(productId) {
  if (!productId) return null;
  return productDetails[productId] || productDetails[Number(productId)] || null;
}

export default productDetails;
